import React from 'react';
import BaseTabs from '@its/components/lib/Container components/TabsContainer/BaseTabs';
import { doSuccessfullRequest } from '@its/httpmanager';
import { setSelectedTemplate } from '../../redux/template/actions';
import { setSelectedTimer } from '../../redux/timer/actions';
import DisplayConfiguration from './DisplayConfiguration';
import Display from './Display';
import { handlePluginList } from './util';
import {
  getTemplate,
  getTimer,
  getPlugins,
} from '../../api';
import {
  DisplayTitle,
  Configuration,
} from '../../i18n/intl';

export default class extends React.Component {

  static contextTypes = {
    store: React.PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    this.tabs = [{
      key: 'Display',
      label: DisplayTitle,
      component: Display,
    }, {
      key: 'Configuration',
      label: Configuration,
      component: DisplayConfiguration,
    }];
    this.onSuccess = (result, dispatch) => {
      dispatch(setSelectedTemplate(result[0].body));
      if (result[1]) {
        dispatch(setSelectedTimer(result[1].body));
      }
      handlePluginList(result[2], dispatch);
    };
  }

  render() {
    const display = this.context.store.getState().app.displays.detail;
    return (
      <BaseTabs
        request={[
          getTemplate(display.templateId),
          display.iterationId ? (
            getTimer(display.iterationId)
          ) : doSuccessfullRequest,
          getPlugins,
        ]}
        onResult={this.onSuccess}
        items={this.tabs}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Display/DisplayModification.js
 **/